import React, {useContext, useState, useEffect} from 'react';
import _ from "lodash";
import "./quizManagementForm.scss"
import {useHistory, withRouter} from "react-router-dom";
import {Formik, Form, Field, FieldArray} from "formik";
import { StoreContext } from '../../store/context'
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select'
import FormControl from '@material-ui/core/FormControl';
import FixedHeaderTable from "../../components/FixedHeaderTable";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import IconButton from "@material-ui/core/IconButton";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import {DatePicker} from "@material-ui/pickers";
import DialogActions from "@material-ui/core/DialogActions";
import Dialog from "@material-ui/core/Dialog";
import moment from "moment-timezone";


const columns = [
    { id: 'title', label: 'Title', minWidth: 170 },
    { id: 'url', label: 'Url', minWidth: 400 },
    {
        id: 'recordCreateDate',
        label: 'Created Date',
        minWidth: 150,
        align: 'right',
        format: (value) => {
            return value? moment(value, "YYYY-MM-DD HH:mm:ss").tz("Asia/Singapore").format('YYYY-MM-DD HH:mma') : "NA"},
    },
    {
        id: 'action',
        label: 'Action',
        minWidth: 170,
        align: 'right',
    },
];

const QuizManagement = () => {
    const history = useHistory();
    const { state, actions } = useContext(StoreContext); // get global state and dispatch function
    const { uuid } = state.formStates.studentRegistration; // get field data from global state
    const { setFormData } = actions.formActions; // export setFormData function
    const { getAllTeachers, getAllTuitionFees, getQuiz, updateQuiz, createQuiz, displayConfirmDialog } = actions.generalActions;
    const { teachers, tuitionFees } = state.generalStates;
    const { getAllProgramLvl } = actions.registrationActions;
    const { quiz } = state.generalStates;
    const studentProgramLvl = state.registrationStates.programLvl;
    const [isDialogVisible, setDialogVisibility] = useState(false);
    const [selectedQuiz, setSelectedQuiz] = useState({});
    const [courses, setCourses] = useState([]);
    const [programLvl, setProgramLvl] = useState([]);
    const [tuitionId, setTuitionId] = useState(0);
    const [title, setTitle] = useState("");
    const [url, setUrl] = useState("");
    const [errorMsg, setErrorMsg] = useState("");

    const [selectedCourse, setSelectedCourse] = useState(null);
    const [selectedProgramLvl, setSelectedProgramLvl] = useState(null);
    const [selectedTeacher, setSelectedTeacher] = useState(null);


    useEffect(() => {
        console.log("Get tuitions")
        getAllTuitionFees();
        getAllTeachers();
        getAllProgramLvl();
        getQuiz();
    }, []);

    // useEffect(() => {
    //     if (tuitionFees.length > 0) {
    //         setCourses(_.uniqBy(tuitionFees, 'courseId'));
    //         setProgramLvl(_.uniqBy(tuitionFees, 'programLvl'));
    //     }
    // }, [tuitionFees])

    const handleProgramLvlOnChange = (e) =>{
        console.log(e.target.value);
        setSelectedProgramLvl(e.target.value);
        setSelectedCourse(null);
        const coursesFilter = _.filter(programLvl, { programLvl: e.target.value });
        setCourses(coursesFilter);
    };

    const handleCourseOnChange = (e) =>{
        console.log(e.target.value);
        setSelectedCourse(e.target.value);
        const courseFilter = _.filter(courses, { courseId: e.target.value });
        setTuitionId(courseFilter.id);
    };

    const handleTeacherOnChange = (e) =>{
        setSelectedTeacher(e.target.value);
        setSelectedCourse(null);
        setSelectedProgramLvl(null);
        const programLvlFilter = _.filter(tuitionFees, { teacherId: e.target.value });
        setProgramLvl(programLvlFilter);
    };


    const goBack = () => {
        history.push("/student/management")
    }

    const handleCreateButton = () => {
        clearAll();
        setTitle("");
        setUrl("");
        setSelectedQuiz(null);
        setDialogVisibility(true);
    }

    const onEditClick = () => {
        history.push("/student/management")
    }

    const handleSubmit = () => {
        if (!title) {
            setErrorMsg("Please fill in the title")
            return;
        }

        if (!url) {
            setErrorMsg("Please fill in the url")
            return;
        }


        if (!selectedQuiz || !selectedQuiz.id) {
            createQuiz(selectedTeacher, selectedCourse, selectedProgramLvl, title, url)
        } else {
            updateQuiz(selectedQuiz.id, selectedTeacher, selectedCourse, selectedProgramLvl, title, url);
        }
        clearAll();
        setDialogVisibility(false);
    };

    const handleClose = () => {
        clearAll();
        setDialogVisibility(false);
    };

    const handleDelete = () => {
        displayConfirmDialog(
            true,
            "Confirmation",
            "Are you sure you want to delete this quiz?",
            false,
            (month) => {
                updateQuiz(selectedQuiz.id, selectedTeacher, selectedCourse, selectedProgramLvl, title, url, "DELETED");
                clearAll();
                setDialogVisibility(false)
            }
        )
    };

    const clearAll = () => {
        setSelectedTeacher(null);
        setSelectedCourse(null);
        setSelectedProgramLvl(null);
    }

    const renderQuizDetails = () => {
        return (
            <div>
                <TextField margin="dense" label="Title"
                           value={title} fullWidth
                           onChange={ e => setTitle(e.target.value)}
                />
                <TextField margin="dense" label="Url" value={url} fullWidth
                           onChange={ e => setUrl(e.target.value)}
                />
            </div>
        )
    };

    const renderAllCourses = () =>{
        return (
            <FormControl fullWidth variant="standard" margin="dense">
                <InputLabel>Course</InputLabel>
                <Select fullWidth value={selectedCourse} onChange={(e, val) => handleCourseOnChange(e)}>
                    {
                        courses && courses.map((value, index) => {
                            return (
                                <MenuItem fullWidth key={value.courseId} value={value.courseId}>{value.subjectName}</MenuItem>
                            );
                        })
                    }
                </Select>
            </FormControl>
        )
    };

    const renderAllProgramLvl = () =>{
        let result = programLvl;
        if (programLvl && programLvl.length > 0) {
            result =  _.orderBy(_.uniqBy(result, 'programLvl'), ['programLvl']);
        }
        return (
            <FormControl fullWidth variant="standard" margin="dense">
                <InputLabel>Program Level</InputLabel>
                <Select fullWidth value={selectedProgramLvl} onChange={(e) => handleProgramLvlOnChange(e)}>
                    {
                        result && result.map((value, index) => {
                            if (studentProgramLvl.length > 0) {
                                const programLvlName = _.find(studentProgramLvl, {id: value.programLvl}).name;
                                return (
                                    <MenuItem fullWidth key={value.programLvl}
                                              value={value.programLvl}>{programLvlName}</MenuItem>
                                );
                            }
                        })
                    }
                </Select>
            </FormControl>
        )
    };


    const renderTeachers = () => {
        return (
            <FormControl fullWidth variant="standard" margin="dense">
                <InputLabel>Teacher</InputLabel>
                <Select label={"Teacher"} value={selectedTeacher} onChange={(e) => handleTeacherOnChange(e)}>
                    {
                        teachers.map((value, index) => {
                            return (
                                <MenuItem key={value.id} value={value.id}>{value.name}</MenuItem>
                            );
                        })
                    }
                </Select>
            </FormControl>
        )
    };

    const onViewDetailClick = (id) => {
        let detail = _.find(quiz, {id});
        setSelectedQuiz(detail);
        setTitle(detail.title);
        setUrl(detail.url);
        let tuitionFee = _.find(tuitionFees, {id: detail.tuitionId});
        const programLvlFilter = _.filter(tuitionFees, { teacherId: tuitionFee.teacherId });
        setProgramLvl(programLvlFilter);
        const coursesFilter = _.filter(programLvlFilter, { programLvl: tuitionFee.programLvl });
        setCourses(coursesFilter);

        setSelectedProgramLvl(tuitionFee.programLvl);
        setSelectedTeacher(tuitionFee.teacherId);
        setSelectedCourse(tuitionFee.courseId);
        setTuitionId(detail.tuitionId);
        setDialogVisibility(true);
    };

    return (
        <div className="quiz-management-form-container">
            <IconButton className="arrowBack" aria-label="back" onClick={() => {goBack()}}>
                <ArrowBackIosIcon fontSize="small" color="primary"/> <span>BACK</span>
            </IconButton>
            <h1 className="header">Quiz Management</h1>
            <div className="paperContainer">
                <Button className="create-btn" variant="contained" color="primary" onClick={handleCreateButton}>
                    Create
                </Button>
            </div>
            <div className="table-container">
                {quiz && <FixedHeaderTable columns={columns} rows={quiz} buttonContent="Edit" buttonAction={onViewDetailClick}/>}
            </div>

            <Dialog open={isDialogVisible} onClose={handleClose} aria-labelledby="form-dialog-title"
                    fullWidth
                    maxWidth = {'md'}>
                <DialogTitle id="form-dialog-title"><h2>Quiz Detail</h2></DialogTitle>
                <DialogContent>
                    {renderQuizDetails()}
                    {renderTeachers()}
                    {renderAllProgramLvl()}
                    {renderAllCourses()}
                    <div className="inline-error">{errorMsg}</div>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="primary">
                        Cancel
                    </Button>
                    <Button onClick={handleDelete} color="primary">
                        Delete
                    </Button>
                    <Button onClick={handleSubmit} color="primary">
                        Submit
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}

export default withRouter(QuizManagement);
